import { convertTimeWithTimezone } from '@/utils/time';
import { BoxV2 as Box } from 'portal-commons';
import React from 'react';
import { DraftRcsCampaign } from '../../types';
import MoreButton from '@/shared_elements/components/MoreButton';
import { snakeToTitleCase } from '@/utils';
import { useHistory, useLocation } from 'react-router-dom';

interface Props {
  campaign: DraftRcsCampaign;
  onDelete: () => void;
}

const DraftRcsCampaignListingRow: React.FC<Props> = ({
  campaign,
  onDelete,
}) => {
  const history = useHistory();
  const location = useLocation();

  const handleRowClick = () => {
    history.push({
      pathname: '/campaign/create',
      state: {
        goBackPage: location.pathname + location.search,
      },
    });
  };

  return (
    <Box as="tr" data-testid="campaignRow" onClick={handleRowClick}>
      <Box
        as="td"
        sx={{ width: 185, minWidth: 185 }}
        data-testid="campaignCreateDate"
      >
        {convertTimeWithTimezone(campaign.createDate)}
      </Box>
      <Box as="td" data-testid="campaignBrandUid">
        {campaign.brandUid}
      </Box>
      <Box as="td" data-testid="campaignBrandName">
        {campaign.brandName}
      </Box>
      <Box as="td" data-testid="campaignHostingRegion">
        {snakeToTitleCase(campaign.hostingRegion)}
      </Box>
      <Box as="td" data-testid="campaignBillingCategory">
        {snakeToTitleCase(campaign.billingCategory)}
      </Box>
      <Box as="td" data-testid="campaignUsecase">
        {snakeToTitleCase(campaign.usecase)}
      </Box>
      <Box
        as="td"
        data-testid="campaignActions"
        sx={{
          float: 'right',
          padding: '6px 8px !important',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <MoreButton<DraftRcsCampaign>
          data={campaign}
          menuClass="tcr-menu"
          data-testid="campaignActionsButton"
          items={[
            {
              label: 'Delete',
              onClick: () => onDelete?.(),
            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default DraftRcsCampaignListingRow;
